import { SPACING_XXL_L } from '@audi/audi-ui-design-tokens';
import styled from 'styled-components';
import { customBreakPoint, mobileBreakPoint } from '~/styles/break-points';
import { DefaultBarHeight } from '~/styles/default-bar';
import {
	transitionDuration,
	transitionDurationLong,
	transitionDurationShort,
	transitionTiming,
	zIndex,
	zIndexContent,
} from '~/styles/tokens';

export const ConfiguratorPageStyle = styled.div`
	display: flex;
	flex-direction: row;
	@media (max-width: 1179px) {
		flex-wrap: wrap;
	}

	.configurator__content {
		flex-grow: 1;
		flex-shrink: 1;
		top: ${DefaultBarHeight}px;
		top: 0;
		z-index: ${zIndexContent - 1};
		flex: 1;
		min-width: 100%;

		${customBreakPoint(
			mobileBreakPoint,
			`
				position: relative;
				top: 0;
				min-width: 0;
			`,
		)}
	}

	.configurator-gallery {
		transition-timing-function: ${transitionTiming};
		transition-duration: ${transitionDuration}ms;
		transition-property: max-width;
		max-width: 100%;
		height: max-content;
	}

	.configurator__content_toggle {
		position: absolute;
		top: ${DefaultBarHeight + 22}px;
		right: 0;
	}

	.configurator__options {
		position: relative;
		max-width: 100%;
		min-width: 100%;
		flex-grow: 0;
		flex-shrink: 0;
		background-color: white;
		transition:
			flex-basis ${transitionDurationLong}ms ${transitionTiming},
			background-color ${transitionDurationShort}ms ${transitionTiming};
		height: auto;
		padding-bottom: ${SPACING_XXL_L}px;
	}

	.configurator__options-version {
		width: 100vw;
		height: 0px;
		position: relative;
		p {
			position: absolute;
			top: -20px;
			right: 10px;
		}
	}

	.configurator__options-extended {
		display: flex;
		flex-basis: 100%;
		flex-direction: column;
		gap: 32px;
		z-index: ${zIndex};
	}
`;
